import MergeEventModal from './MergeEventModal';

export default MergeEventModal;
